import * as React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { type kintoneApp } from '../util/kintone/kintoneAppsDialog';

interface Item {
    name: string;
}

// 選択されたアイテムの状態を表す型
interface SelectedItemsState<T extends Item> {
    items: T[];
    setItems: React.Dispatch<React.SetStateAction<T[]>>;
}

type Props = {
    file: SelectedItemsState<File>;
    kintoneApp: SelectedItemsState<kintoneApp>;
}

const SelectedItemListTable = (props: Props) => {
    const fileList = props.file.items ?? [];
    const kintoneAppList = props.kintoneApp.items;

    const onClickRemoveItem = <T extends Item>(itemToRemove: T, state: SelectedItemsState<T>) => {
        const updatedItems = state.items.filter((item) => item !== itemToRemove);
        state.setItems(updatedItems);
    };

    return (
        <React.Fragment>
            {fileList.length > 0 && (
                <React.Fragment>
                    <Typography variant='h6'>選択されたファイル</Typography>
                    <Card variant='outlined'>
                        <TableContainer>
                            <Table>
                                <TableBody sx={{ maxWidth: '100px' }}>
                                    {fileList.map((file, index) => (
                                        <TableRow key={index}>
                                            <TableCell align='center' sx={{ maxWidth: '300px', height: '20px', padding: '8px' }}>
                                                {file.name}
                                            </TableCell>
                                            <TableCell align='center' sx={{ padding: '8px' }}>
                                                <IconButton sx={{ padding: '0px' }} onClick={() => onClickRemoveItem(file, props.file)}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>
                </React.Fragment>
            )}
            {kintoneAppList.length > 0 && (
                <React.Fragment>
                    <Typography variant='h6'>選択されたkintoneアプリ</Typography>
                    <Card variant='outlined'>
                        <TableContainer>
                            <Table>
                                <TableBody sx={{ maxWidth: '100px' }}>
                                    {kintoneAppList.map((kintoneApp, index) => (
                                        <TableRow key={index}>
                                            <TableCell align='center' sx={{ maxWidth: '300px', height: '20px', padding: '8px' }}>
                                                {kintoneApp.name}
                                            </TableCell>
                                            <TableCell align='center' sx={{ padding: '8px' }}>
                                                <IconButton sx={{ padding: '0px' }} onClick={() => onClickRemoveItem(kintoneApp, props.kintoneApp)}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default SelectedItemListTable;
